export const EARTH_RADIUS_KM = 6371;

/** Lat/lon (deg) + altitude (km) → ECEF km (matches old globe). */
export function latLonAltToEcef(lat: number, lon: number, altKm: number): [number, number, number] {
  const r = EARTH_RADIUS_KM + altKm;
  const phi = ((90 - lat) * Math.PI) / 180;
  const lambda = ((lon + 180) * Math.PI) / 180;
  return [-r * Math.sin(phi) * Math.cos(lambda), r * Math.cos(phi), r * Math.sin(phi) * Math.sin(lambda)];
}

export function ecefToScene(ecef: [number, number, number], scale = 1 / EARTH_RADIUS_KM): [number, number, number] {
  return [ecef[0] * scale, ecef[1] * scale, ecef[2] * scale];
}
